"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const aws_map_1 = require("@kyruus/aws-map");
const gmap_1 = require("@kyruus/gmap");
const styles_1 = require("./styles");
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const Map = ({ locations, config, awsMapConfig, googleMapsUrl, 'data-testid': dataTestId }) => {
    var _a, _b;
    return (react_1.default.createElement(styles_1.MapContainer, { "data-testid": dataTestId, className: "map-container", height: (_a = config.maps_config) === null || _a === void 0 ? void 0 : _a.container_height },
        react_1.default.createElement(styles_1.MapContainerInner, null, ((_b = config.maps_config) === null || _b === void 0 ? void 0 : _b.location_service_provider) !== 'aws' ? (react_1.default.createElement(gmap_1.DynamicGmap, { url: googleMapsUrl || '', locations: locations, enabledLocationIds: new Set(locations.map((loc) => loc.id)), mapOptions: {
                maxZoom: 16,
                fullscreenControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                styles: [
                    {
                        featureType: 'poi',
                        stylers: [{ visibility: 'off' }]
                    }
                ]
            } })) : (react_1.default.createElement(aws_map_1.AwsMap, { awsMapConfig: awsMapConfig, locations: locations })))));
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)(Map);
//# sourceMappingURL=map.js.map